




































import {
  Component,
  Emit,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  UrgentNotificationDto,
  UserNotificationDto
} from '@eurogast/hub-client-typescript';
import NotificationProductAttachments from '@/notifications/NotificationProductAttachments.vue';
import NotificationUrlAttachment from '@/notifications/NotificationUrlAttachment.vue';
import { StaticLinks } from '@/common/StaticLinks';

@Component({
  components: {
    NotificationUrlAttachment,
    NotificationProductAttachments
  }
})
export default class NotificationModalContent extends Vue {

  get notification(): UserNotificationDto {
    return this.urgentNotification.mostRecentUnread;
  }

  get notificationCenterUrl(): string {
    return StaticLinks.notificationCenter;
  }

  @Prop({required: true})
  public urgentNotification: UrgentNotificationDto;

  @Emit()
  public close() {

  }
}
